import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/features/auth/AuthContext';
import { AuthGate } from '@/features/auth/AuthGate';
import { AppRoutes } from '@/routes';
import { useDirectionEffect } from '@/lib/useDirection';
import { NavigationGuardProvider } from '@/components/layout/NavigationGuardContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Refetch when the browser comes back online. Without this, a
      // transient network blip (lift, tunnel, wifi flap) leaves any
      // in-flight query stuck on "Loading…" forever because TanStack's
      // default retry budget had already been spent against /dev/null.
      refetchOnReconnect: true,
      staleTime: 5 * 60 * 1000,
      // 3 retries with exponential backoff capped at 30s. Defends
      // against transient PostgREST 503s and Supabase pooler hiccups
      // that would otherwise surface as a permanent skeleton.
      retry: 3,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
  },
});

function DirectionEffect() {
  useDirectionEffect();
  return null;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <NavigationGuardProvider>
          <AuthProvider>
            <DirectionEffect />
            <AuthGate>
              <AppRoutes />
            </AuthGate>
          </AuthProvider>
        </NavigationGuardProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
